<template>
  <div class="meta_box">
    <el-row :gutter="20">
      <el-col :xs="24">
        <div class="description_title mb-5 md:px-24 text-center">
          <p class="px-10 leading-relaxed vhtml_component" v-html="description2" v-if="optIn || noOptIn"></p>
          <p class="px-10 leading-relaxed vhtml_component" v-html="description" v-else></p>
        </div>
      </el-col>
      <el-col :xs="24" class="button_box">
        <el-button
          class="el-button blue_button"
          data-testid="fund"
          @click="handlerOptInNowChange(false)"
          v-if="optIn && !noOptIn"
          :disabled="disabled"
        >
          {{ $t(`promotion.${this.$route.params['campaignName']}.optout.button`) }}</el-button
        >
        <el-button
          class="el-button blue_button"
          data-testid="fund"
          @click="handlerOptInNowChange(true)"
          v-if="!optIn && !noOptIn"
          :disabled="disabled"
        >
          {{ $t(`promotion.${this.$route.params['campaignName']}.optin.button`) }}</el-button
        >
      </el-col>
      <el-col :xs="24" class="agreeTnc_box">
        <a :href="tncLink" target="_blank" data-testid="tnc">
          {{ $t(`promotion.${this.$route.params['campaignName']}.tnc`) }}
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { autoOptInEnum } from '@/constants/sumsub';
import { apiCampaignOpt } from '@/resource';

export default {
  name: 'OptInOut',
  props: {
    description: {
      type: String,
      default: null
    },
    description2: {
      type: String,
      default: null
    },
    optIn: {
      type: Boolean,
      default: false
    },
    tncLink: {
      type: String,
      default: null
    },
    autoOptIn: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      disabled: false
    };
  },
  computed: {
    campaignID() {
      return this.$route.params['campaignId'];
    },
    noOptIn() {
      switch (this.autoOptIn) {
        case autoOptInEnum.noOptIn:
          return true;
      }
      return false;
    },
  },
  methods: {
    handlerOptInNowChange(optinout) {
      this.disabled = true;
      apiCampaignOpt(this.campaignID, optinout).then(resp => {
        if (resp.data.data) {
          this.restartPage();
        } else {
          this.showError();
        }
      });
    },
    restartPage() {
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
    showError() {
      this.$message({
        message: this.$t('common.field.failed'),
        type: 'error',
        duration: 5000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/promotion/clientPortalSettings.scss';
</style>
